module.exports = __webpack_public_path__ + "img/nus-fintech-soc.4f0fa1fd.jpeg";